import { render, staticRenderFns } from "./SubMember.vue?vue&type=template&id=3aafd9d8&scoped=true&"
import script from "./SubMember.vue?vue&type=script&lang=js&"
export * from "./SubMember.vue?vue&type=script&lang=js&"
import style0 from "./SubMember.vue?vue&type=style&index=0&id=3aafd9d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aafd9d8",
  null
  
)

export default component.exports